/** Normalize to hostname only (lowercase, no scheme/www). */
export function normalizeInstitutionHost(domain: string): string {
  const trimmed = domain.trim().toLowerCase().replace(/^https?:\/\//i, '');
  return trimmed.split('/')[0].replace(/^www\./, '');
}

/**
 * Ordered remote logo candidates (no API keys in the browser).
 * Falls through on `img` `onError` in the UI — different CDNs often have better icons for .edu domains.
 */
export function institutionLogoCandidateUrls(domain: string, size = 64): string[] {
  const host = normalizeInstitutionHost(domain);
  if (!host) return [];
  const enc = encodeURIComponent(host);
  return [
    `https://www.google.com/s2/favicons?domain=${enc}&sz=${size}`,
    `https://unavatar.io/${enc}`,
    `https://icon.horse/icon/${enc}`,
    `https://icons.duckduckgo.com/ip3/${host}.ico`
  ];
}

/** First candidate only; prefer `institutionLogoCandidateUrls` for fallbacks in the UI. */
export function institutionFaviconUrl(domain: string, size = 64): string {
  const urls = institutionLogoCandidateUrls(domain, size);
  return urls[0] ?? '';
}
